'use client'; // Needs useEffect

import React, { useEffect, useState } from 'react';
import { QuizStep } from '../../lib/quiz-definition';

interface LoadingStepProps {
    step: QuizStep;
    onComplete: (nextStepId: string) => void;
}

const messages = [
    { percent: 0, text: "Analyzing your results..." },
    { percent: 25, text: "Figuring your preferences..." },
    { percent: 67, text: "Building Your Maps.." },
    { percent: 100, text: "You're Done!!" },
];

const TOTAL_DURATION = 2500; // Total time for loading simulation in ms

const LoadingStep: React.FC<LoadingStepProps> = ({ step, onComplete }) => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [displayedPercent, setDisplayedPercent] = useState(0);

    useEffect(() => {
        const timers: NodeJS.Timeout[] = [];
        const numMessages = messages.length;
        const timePerStep = TOTAL_DURATION / numMessages;

        messages.forEach((message, index) => {
            const delay = index * timePerStep;
            timers.push(
                setTimeout(() => {
                    setCurrentMessageIndex(index);
                    // Update percentage slightly delayed for visual effect if needed
                    // Or update instantly:
                    setDisplayedPercent(message.percent);
                }, delay)
            );
        });

        // Final timer to trigger completion after the last message
        timers.push(
            setTimeout(() => {
                if (step.nextStepId) {
                    onComplete(step.nextStepId);
                }
            }, TOTAL_DURATION)
        );

        // Cleanup all timers on unmount
        return () => timers.forEach(clearTimeout);

    }, [step, onComplete]); // Rerun effect if step or onComplete changes

    return (
        <div className="quiz-step loading-step-content">
            <div className="loading-spinner"></div>
            {/* Display current percentage and text */}
            <p className="loading-text loading-percent">{displayedPercent}%</p>
            <p className="loading-text loading-message">{messages[currentMessageIndex].text}</p>
        </div>
    );
};

export default LoadingStep; 